"use client";
import React from "react";

import { useFlags } from "@stadium/services/launch-darkly";
import { useFeatureFlag } from "@stadium/services/launch-darkly/use-feature-flag";

const withFeatureFlagToggle =
  ({ Component, FeaturedFlagComponent, flag, loader = null }) =>
  (props) => {
    const { [flag]: selectedFlag } = useFlags();
    const { isReady } = useFeatureFlag();

    if (!isReady) {
      return loader;
    }

    if (selectedFlag && FeaturedFlagComponent) {
      return <FeaturedFlagComponent {...props} />;
    }
    return <Component {...props} />;
  };

export default withFeatureFlagToggle;
